import { jsx as _jsx } from "react/jsx-runtime";
import { List } from "@mui/material";
import { forwardRef } from "react";
export const UiList = forwardRef((props, ref) => (_jsx(List, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_list.js.map